// @ts-strict
import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { LMReportFieldPickerService } from './lm-report-field-picker.service';
import { Observable, Subscription, filter, map, tap } from 'rxjs';
import { ReportFieldPickerConstants } from './lm-report-field-picker.constants';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lm-report-field-picker-viewer',
  templateUrl: './lm-report-field-picker-viewer.component.html',
  styleUrls: ['./lm-report-field-picker-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('100ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('100ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class LMReportFieldPickerViewerComponent implements OnInit, OnDestroy {
  readonly ViewerConstants = ReportFieldPickerConstants.Viewer;

  selectedFields$!: Observable<{ key: string; value: string }[]>;
  fieldEventType$!: Observable<string>;

  private subs$: Subscription = new Subscription();

  constructor(private lmReportFieldPickerService: LMReportFieldPickerService, private ref: ElementRef) {}

  ngOnInit(): void {
    this.selectedFields$ = this.lmReportFieldPickerService.selectedFields$.pipe(map((res) => [...Array.from(res, ([key, value]) => ({ key, value }))]));

    // UX: scroll to end of list
    this.subs$.add(
      this.lmReportFieldPickerService.fieldEventType$
        .pipe(
          filter((res) => res === 'add'),
          tap((res) => (this.scrollToBottom(), res))
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }

  onRemoveField(id: string) {
    if (id) {
      this.lmReportFieldPickerService.removeField(id);
    }
  }

  // component utility methods
  trackByKey(index: any, item: { key: any }) {
    return item.key;
  }

  private scrollToBottom(): void {
    this.ref?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });
  }
}
